import { useMutation } from 'react-query'
import swal from 'sweetalert'
import { privateAPI } from '../config/constants'
import { decrypt } from '../functions/globalFunctions'
import * as generalTypes from '../redux/types/generalTypes'

/* eslint-disable */
//--------------------------- callback functions for react queries (name of callbacks are same as actions name in redux folder) ---------------------------
const whatsappCustomers = async () => {
  const res = await privateAPI.get('/whatsapp/get-subscribed-customer')
  return decrypt(res?.data)?.data
}

const getVendorShops = async () => {
  const res = await privateAPI.post(`/general/get-vendor-shop-names`)
  const data = decrypt(res.data)
  return [...data]
}

const getInvoicesByFilterOffline = async (data) => {
  const res = await privateAPI.post(`/offline/get-users-by-filter`, {
    data,
  })
  return decrypt(res.data)
}

// const getInvoicesByFilterOnline = async (data) => {
//   const payload = encrypt(data)
//
//   const res = await privateAPI.post(`/online/get-users-by-filter`, {
//     data: payload,
//   })
//   return decrypt(res.data)
// }

const getVendorDiscounts = async (type) => {
  const res = await privateAPI.post(`/general/get-vendor-discounts`, {
    data: { type },
  })
  return decrypt(res.data)
}

const getMonitoringNames = async (payload) => {
  const { channel, dispatch } = payload

  dispatch({
    type: generalTypes.EMPTY_MONITORING_NAMES,
  })
  const res = await privateAPI.post(`/campaign/get-monitoring-names`, {
    data: {
      channel,
    },
  })
  return decrypt(res.data)
}

const getMonitorings = async (campaign) => {
  const res = await privateAPI.post(`/campaign/get-monitorings`, {
    data: { campaign },
  })
  return decrypt(res.data)
}

const getCampaignDetails = async (campaign) => {
  const res = await privateAPI.post(`/campaign/get-campaign-details/${campaign}`)
  // console.log('data in hooks', decrypt(res.data))
  return decrypt(res.data)
}

const getEmailCampaignDetails = async (campaign) => {
  const res = await privateAPI.post(`/campaign/get-email-campaign-details/${campaign}`)
  return decrypt(res.data)
}

const getCampaignCustomer = async (payload) => {
  const { number, campaignId } = payload

  const res = await privateAPI.post(`/campaign/get-campaign-customer-data`, {
    data: {
      number,
      campaignId,
    },
  })
  let resp = decrypt(res.data)
  return resp.orders
}

const getCustomerCluster = async (data) => {
  const res = await privateAPI.post(`/campaign/get-customer-cluster`, {
    data,
  })
  return decrypt(res.data)
}

const getProductCampaignFiltersOffline = async () => {
  // const res = await privateAPI.post(`offline/get-product-filters`, {
  const res = await privateAPI.post(`offline/get-product-filters-saved`)
  return res
}

const getCustomerInsights = async (data) => {
  const res = await privateAPI.post(`/campaign/get-customer-insights/color`, {
    data,
  })
  return decrypt(res.data)
}

const getCustomerInsightsCategory = async (data) => {
  const res = await privateAPI.post(`/campaign/get-customer-insights/category`, { data })
  return decrypt(res.data)
}

const getCustomerInsightsSize = async (data) => {
  const res = await privateAPI.post(`/campaign/get-customer-insights/size`, { data })
  return decrypt(res.data)
}

const getCustomerByColor = async (data) => {
  const res = await privateAPI.post(`/campaign/get-customer-by-color`, { data })
  if (res) {
    let resp = decrypt(res.data)

    return resp
  }
}

const getCustomerByCategory = async (data) => {
  const res = await privateAPI.post(`/campaign/get-customer-by-category`, {
    data,
  })
  return decrypt(res.data)
}

const getCustomerBySize = async (data) => {
  const res = await privateAPI.post(`/campaign/get-customer-by-size`, {
    data,
  })
  return decrypt(res.data)
}

const getCities = async () => {
  const res = await privateAPI.get(`/general/get-vendor-cities`)
  return decrypt(res.data)
}

const getBrevoEmailTemplates = async () => {
  try {
    const res = await privateAPI.post(`/campaign/get-brevo-email-templates-list`)
    return res?.data?.data
  } catch (error) {
    swal('', error.response.data.message, 'error')
  }
}

const getBrevoFolders = async () => {
  try {
    const res = await privateAPI.post(`/campaign/get-brevo-email-folders-list`)
    return res?.data?.data
  } catch (error) {
    swal('', error.response.data.message, 'error')
  }
}
const getEmailService = async (payload) => {
  try {
    const res = await privateAPI.post(`/get-email-service`, { data: payload })
    console.log('getEmailService - - - ->', res?.data)
    return res?.data
  } catch (error) {
    swal('', error.response.data.message, 'error')
  }
}

const createEmailCampaign = async (payload) => {
  try {
    const res = await privateAPI.post(`/campaign/create-brevo-email-campaign`, { data: payload })
    return res.data
  } catch (error) {
    swal('', error.response.data.message, 'error')
  }
}

const updateEmailCampaignStatus = async (payload) => {
  try {
    const res = await privateAPI.post(`/campaign/update-email-campaign-status`, { data: payload })
    return res.data
  } catch (error) {
    swal('', error.response.data.message, 'error')
  }
}

const getConditionalCustomerCount = async (payload) => {
  try {
    const res = await privateAPI.post('/conditionBasedCampaign/get-Customer-For-Campaign', {
      data: payload,
    })
    return decrypt(res?.data)
  } catch (error) {
    console.log(error)
  }
}

const getConditionalCustomerMobiles = async (payload) => {
  try {
    let data = { ...payload }
    const res = await privateAPI.post('/conditionBasedCampaign/get-Customer-For-Campaign', {
      data: data,
    })
    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}

const saveConditionalCampaignData = async (payload) => {
  try {
    const res = await privateAPI.post('/conditionBasedCampaign/save-campaign', { data: payload })
    return decrypt(res.data)
    // console.log('saveConditionalCampaignData Payload', payload)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}

const updateSaveConditionalCampaignData = async (payload) => {
  try {
    console.log('in update api', payload)
    const res = await privateAPI.put('/conditionBasedCampaign/update-save-campaign', {
      data: payload,
    })
    console.log('helo', res.data)
    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}

const updateSaveConditionalCampaignDataById = async (data) => {
  try {
    console.log('in update api BY ID', data)
    const res = await privateAPI.put('/conditionBasedCampaign/update-save-campaign-by-id', {
      data,
    })
    console.log('helo', res.data)
    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}

const getAllSaveConditionalCampaign = async () => {
  try {
    const res = await privateAPI.post('/conditionBasedCampaign/get-all-saved-campaigns')
    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}

const deleteConditionalCampaignById = async (payload) => {
  try {
    const res = await privateAPI.post('/conditionBasedCampaign/delete-campaign-by-id', {
      data: payload,
    })
    return decrypt(res.data)
  } catch (error) {
    swal('', error.response.data.message || 'Server Error', 'error')
  }
}

const updateClusterStatus = async (payload) => {
  try {
    privateAPI.post(`/conditionBasedCampaign/update-cluster-status`, {
      data: { ...payload },
    })
  } catch (error) {
    console.log('Error', error)
  }
}

// eslint-disable-next-line
//---------------------------------------------------------------- React Query Hooks ----------------------------------------------------------------
export const useGetWhatsappCustomers = () => {
  return useMutation(whatsappCustomers, {
    onError: () => {},
  })
}

export const useGetVendorShops = () => {
  return useMutation(getVendorShops)
}

export const useGetInvoicesByFilterOffline = (dispatch) => {
  return useMutation(getInvoicesByFilterOffline, {
    onSuccess: (data) => {
      if (data?.result?.length > 0) {
        dispatch({
          type: generalTypes.GET_QUERY,
          payload: data.query,
        })
        dispatch({
          type: generalTypes.OFFLINE_FILTERED_USERS,
          payload: data.result,
        })
      } else {
        swal('', 'No Users for this Selection', 'info')
      }
    },
  })
}

// export const useGetInvoicesByFilterOnline = (dispatch) => {
//   return useMutation(getInvoicesByFilterOnline, {
//     onSuccess: (data) => {
//       if (data?.result?.length > 0) {
//         dispatch({
//           type: generalTypes.ONLINE_FILTERED_USERS,
//           payload: data.result,
//         })
//       } else {
//         swal('', 'No Users for this Selection', 'info')
//       }
//     },
//   })
// }

export const useGetVendorDiscounts = (dispatch) => {
  return useMutation(getVendorDiscounts, {
    onSuccess: (data) => {
      dispatch({
        type: generalTypes.VENDOR_DISCOUNTS,
        payload: data,
      })
    },
  })
}

export const useGetMonitoringNames = (dispatch) => {
  return useMutation(getMonitoringNames, {
    onSuccess: (data) => {
      dispatch({
        type: generalTypes.MONITORING_NAMES,
        payload: data,
      })
    },
  })
}

export const useGetMonitorings = (setSingleData) => {
  return useMutation(getMonitorings, {
    onSuccess: (data) => {
      setSingleData(data)
    },
  })
}

export const useGetCampaignDetails = (
  setCampaignDetails,
  setShopWise,
  setAtRisk,
  setNeedAttention,
  setLostCustomer,
  setBaseCUstomer,
  setStarCUstomer,
  setChampionCustomer,
  setNotToLoosCustomer,
  setCategoryResp,
  setColorResp,
  setProductResp,
) => {
  return useMutation(getCampaignDetails, {
    onSuccess: (data) => {
      console.log('data in api --------', data)
      setCampaignDetails(data?.result)
      setShopWise(data?.shops)
      setAtRisk(data?.risk)
      setNeedAttention(data?.needattantion)
      setLostCustomer(data?.lost)
      setBaseCUstomer(data?.base)
      setStarCUstomer(data?.star)
      setChampionCustomer(data?.champions)
      setNotToLoosCustomer(data?.mustnotlose)
      setCategoryResp(data?.category)
      setColorResp(data?.color)
      setProductResp(data?.products)
    },
  })
}

export const useGetEmailCampaignDetails = (
  setCampaignDetails,
  setShopWise,
  setAtRisk,
  setNeedAttention,
  setLostCustomer,
  setBaseCUstomer,
  setStarCUstomer,
  setChampionCustomer,
  setNotToLoosCustomer,
  setCategoryResp,
  setColorResp,
  setProductResp,
) => {
  return useMutation(getEmailCampaignDetails, {
    onSuccess: (data) => {
      setCampaignDetails(data?.result)
      setShopWise(data?.shops)
      setAtRisk(data?.risk)
      setNeedAttention(data?.needattantion)
      setLostCustomer(data?.lost)
      setBaseCUstomer(data?.base)
      setStarCUstomer(data?.star)
      setChampionCustomer(data?.champions)
      setNotToLoosCustomer(data?.mustnotlose)
      setCategoryResp(data?.category)
      setColorResp(data?.color)
      setColorResp(data?.products)
    },
  })
}

export const useGetCampaignCustomer = (setCustomerData) => {
  return useMutation(getCampaignCustomer, {
    onSuccess: (data) => {
      setCustomerData(data)
    },
  })
}

export const useGetCustomerCluster = (setCustomers) => {
  return useMutation(getCustomerCluster, {
    onSuccess: (data) => {
      setCustomers(data)
    },
  })
}

export const useGetProductCampaignFiltersOffline = (dispatch) => {
  return useMutation(getProductCampaignFiltersOffline, {
    onSuccess: (res) => {
      dispatch({
        type: generalTypes.OFFLINE_PRODUCT_FILTERS,
        payload: decrypt(res.data),
      })
      // dispatch({
      //   type: generalTypes.GET_QUERY,
      //   payload: res.data?.query,
      // })
    },
  })
}

export const useGetCustomerInsights = (setMonthlyData) => {
  return useMutation(getCustomerInsights, {
    onSuccess: (data) => {
      setMonthlyData(data)
    },
  })
}

export const useGetCustomerInsightsCategory = (setMonthlyData) => {
  return useMutation(getCustomerInsightsCategory, {
    onSuccess: (data) => {
      setMonthlyData(data)
    },
  })
}

export const useGetCustomerInsightsSize = (setMonthlyData) => {
  return useMutation(getCustomerInsightsSize, {
    onSuccess: (data) => {
      setMonthlyData(data)
    },
  })
}

export const useGetCustomerByColor = (setCustomers) => {
  return useMutation(getCustomerByColor, {
    onSuccess: (data) => {
      setCustomers(data)
    },
  })
}

export const useGetCustomerByCategory = (setCustomers) => {
  return useMutation(getCustomerByCategory, {
    onSuccess: (data) => {
      setCustomers(data)
    },
  })
}

export const useGetCustomerBySize = (setCustomers) => {
  return useMutation(getCustomerBySize, {
    onSuccess: (data) => {
      setCustomers(data)
    },
  })
}

export const emailCampaignsFun = async (data) => {
  try {
    const res = await privateAPI.post('/campaign/get-email-template', { data })
    if (res) {
      return res
    }
  } catch (err) {
    console.log(err)
  }
}

export const useGetCities = () => {
  return useMutation(getCities)
}

export const useGetBrevoEmailTemplates = () => {
  return useMutation(getBrevoEmailTemplates)
}

export const useGetBrevoFolders = () => {
  return useMutation(getBrevoFolders)
}

export const useGetEmailService = () => {
  return useMutation(getEmailService)
}

export const useCreateEmailCampaign = () => {
  return useMutation(createEmailCampaign)
}

export const useUpdateEmailCampaignStatus = () => {
  return useMutation(updateEmailCampaignStatus)
}

export const useGetConditionalCustomerCount = (dispatch) => {
  return useMutation(getConditionalCustomerCount, {
    onSuccess: (payloadData) => {
      dispatch({
        type: generalTypes.GET_CONDITIONAL_CUSTOMER_COUNT,
        payload: payloadData,
      })
    },
    onError: (error) => {
      console.log('ERROR: ', error)
    },
  })
}

export const useGetConditionalCustomerMobiles = (dispatch) => {
  return useMutation(getConditionalCustomerMobiles, {
    onSuccess: (payloadData) => {
      dispatch({
        type: generalTypes.GET_CONDITIONAL_CUSTOMER_NUMBERS,
        payload: payloadData,
      })
    },
    onError: (error) => {
      console.log('ERROR', error)
    },
  })
}

export const useSaveConditionalCampaignData = (dispatch) => {
  return useMutation(saveConditionalCampaignData, {
    onSuccess: (payloadData) => {
      dispatch({
        type: generalTypes.SAVE_CONDITIONAL_CAMPAIGN,
        payload: payloadData,
      })
    },
    onError: (error) => {
      console.log('ERROR', error)
    },
  })
}
export const useUpdateSaveConditionalCampaignData = (dispatch) => {
  return useMutation(updateSaveConditionalCampaignData, {
    onSuccess: (payloadData) => {
      dispatch({
        type: generalTypes.UPDATE_SAVE_CONDITIONAL_CAMPAIGN,
        payload: payloadData,
      })
    },
    onError: (error) => {
      console.log('ERROR', error)
    },
  })
}

export const useUpdateSaveConditionalCampaignDataById = (dispatch) => {
  return useMutation(updateSaveConditionalCampaignDataById, {
    onSuccess: (payloadData) => {
      dispatch({
        type: generalTypes.UPDATE_SAVE_CONDITIONAL_CAMPAIGN_BY_ID,
        payload: payloadData,
      })
    },
    onError: (error) => {
      console.log('ERROR', error)
    },
  })
}

export const useGetAllSaveConditionalCampaignData = () => {
  return useMutation(getAllSaveConditionalCampaign)
}

export const useDeleteConditionalCampaignByIdData = (dispatch) => {
  return useMutation(deleteConditionalCampaignById, {
    onSuccess: (payloadData) => {
      dispatch({
        type: generalTypes.DELETE_SAVE_CAMPAIGN,
        payload: payloadData,
      })
    },
    onError: (error) => {
      console.log('ERROR', error)
    },
  })
}
export const useUpdateClusterStatus = (dispatch) => {
  return useMutation(updateClusterStatus, {
    onSuccess: (payloadData) => {
      dispatch({
        type: generalTypes.UPDATE_CLUSTER_STATUS,
        payload: payloadData,
      })
    },
    onError: (error) => {
      console.log('ERROR', error)
    },
  })
}
